/**
 * Tier3Dialogues - Late Game & Polymath Synthesis Dialogue Scripts
 * 
 * Dark Forest Portfolio Game
 * Pure data dictionary containing third-meeting dialogue lines for all 5 NPCs.
 * Displayed after the player has visited 3+ zones across the Dark Forest.
 * Tone is celebratory, affirming, and reflective of the player's holistic systems thinking.
 */

export const Tier3Dialogues = Object.freeze({
  mentor: Object.freeze([
    "You've returned. And this time, you've walked all the paths.",
    "When you first arrived, you were uncertain. Look at you now.",
    "You've mastered web development. You've ventured into data science. You've touched mobile development.",
    "That's not specialization. That's wisdom.",
    "Most developers choose one path and walk it forever. You chose to see the whole forest.",
    "The summit reveals itself to those who understand that no single clearing holds all the answers.",
    "You're ready now. Go to the peak. There's someone waiting."
  ]),

  fullstack: Object.freeze([
    "You're back. And you've seen everything the forest has to offer.",
    "EduVault and CodeXcape taught you web development fundamentals.",
    "But you didn't stop there. You explored data science. You built mobile apps.",
    "That makes you the kind of developer I aspire to be—someone who understands the entire ecosystem.",
    "Full-stack development isn't just about code layers. It's about understanding how systems interconnect.",
    "You've proven you understand that.",
    "I'm proud to have been part of your journey. Now go—your future awaits."
  ]),

  ada: Object.freeze([
    "The seeker returns, having sought in all directions.",
    "Your sentiment analysis work was precise. But you didn't stop at analysis.",
    "You learned how data powers applications. How models serve users. How research becomes reality.",
    "That's the rarest skill in data science—not just mathematical rigor, but understanding why it matters.",
    "Published research is wonderful. But you've learned that research divorced from application is incomplete.",
    "You're a data scientist who builds. A researcher who ships. Few are both.",
    "The summit awaits someone who understands patterns at every level. That's you now."
  ]),

  mobilearch: Object.freeze([
    "You've completed the circuit. You've seen every zone.",
    "GMMX showed you mobile development. But you kept learning.",
    "You understood that mobile apps don't exist in isolation—they're the intersection of backends, data, and user experience.",
    "That's systems thinking. That's architectural thinking.",
    "The best mobile developers aren't mobile specialists—they're generalists who happen to excel at mobile.",
    "You're that kind of developer now.",
    "Go to the summit. You've earned what's waiting there."
  ]),

  futureyou: Object.freeze([
    "You made it. You've walked all the paths.",
    "I remember when I stood where you stand—uncertain, exploring, learning.",
    "Web development taught you structure. Data science taught you insight. Mobile development taught you distribution.",
    "You're not a specialist. You're a polymath. A developer who understands that great software requires understanding across disciplines.",
    "The dark forest wasn't trying to confuse you. It was teaching you that no single clearing is complete.",
    "You came here to discover yourself. Now you know who you are—a developer who builds, who thinks, who learns everywhere.",
    "Your journey doesn't end at the summit. It begins there. The forest goes deeper than you've seen.",
    "And you have the foundation to walk it."
  ])
});

export default Tier3Dialogues;
